import { Component, Input, OnInit } from '@angular/core';
import { TipoDeclinioPropostaEnum } from 'src/app/api/module/erp/shared/enumerable/tipo-declinio-proposta-enum';

@Component({
  selector: 'app-emails-declinio-proposta',
  templateUrl: './emails-declinio-proposta.component.html',
  styleUrls: ['./emails-declinio-proposta.component.scss']
})
export class EmailsDeclinioPropostaComponent implements OnInit {
  @Input() tipoPropostaDeclinada!: TipoDeclinioPropostaEnum;
  @Input() mostrarEmailDeclinado: boolean = false;
  @Input() mostrarEmailDeclinadoPortabilidade: boolean = false;
  @Input() mostrarEmailDeclinadoSumulaNovaAdesao: boolean = false;
  @Input() dataDeclinio: any;
  @Input() horaDeclinio: any;
  @Input() nomeTitular: any;
  @Input() codigoProposta: any;
  @Input() motivoDeclinio: any;


  constructor() { }

  ngOnInit(): void {
    this.tipoDeclinio();
  }

  tipoDeclinio() {
    if (this.tipoPropostaDeclinada == TipoDeclinioPropostaEnum.DECLINIO_MOTIVO) {
      this.mostrarEmailDeclinado = true;
    } else if (this.tipoPropostaDeclinada == TipoDeclinioPropostaEnum.DECLINIO_PORTABILIDADE) {
      this.mostrarEmailDeclinadoPortabilidade = true;
    } else {
      this.mostrarEmailDeclinadoSumulaNovaAdesao = true;
    }
  }
}
